<template>
<div class="cal-date"
    @click="selectDate"
    :class ="{
      'cal-date--selected' : this.dateItem.isSelected,
      'cal-date--oom' : isOutOfMonth,
      'cal-date--disabled' : isDisabled,
      'cal-date--bestprice' : isBestPrice,
      'cal-date--start-date' : this.dateItem.isStartDate,
      'cal-date--max-selection' : this.dateItem.isMaxSelection,
      'cal-date--min-selection' : this.dateItem.isMinSelection,
      'cal-date--last-date-available' : this.dateItem.isLastAvailableDate,
      'cal-date--disabled-start-date' : this.dateItem.isNotAllowedAsStartDate,
    }">
    <span class="cal-date__day">{{ dayOfMonth }}</span>
    <span class="cal-date__price"><span class="cal-date__price-currency" v-if="dayPrice">€</span> {{ dayPrice }}</span>
    <span class="cal-date__total-price"><span class="cal-date__price-currency" v-if="dayPrice">€</span> {{ dayPrice }}</span>
    <span class="cal-date__start-date-info" v-if="this.dateItem.isNotAllowedAsStartDate">
      <span class="icon icon-info" aria-label="Information for start date"></span>
    </span>
    <span v-if="this.dateItem.isNotAllowedAsStartDate"
          class="cal-date__info-tooltip"
          :class="{
            'hidden' : this.dateItem.showTooltip === false
          }">
      {{ this.infoTooltipLabel }}
    </span>
</div>
</template>

<script>
    export default {
      props: {
        dateItem: Object,
        shownMonth: Number,
        totalPrice: String,
        initialDate: {
          type: String,
          required: false,
          default: null,
        },
        infoTooltipLabel: String
      },
      created() {

        if (this.initialDate) {

          let initDate = new Date(this.initialDate);
          let dtItemDate = new Date(this.dateItem.date);

          // todo ... jesus christ
          let initDateString = initDate.getDate() + '-' + (initDate.getMonth()+1) + '-' + initDate.getFullYear();
          let dtItemDateString = dtItemDate.getDate() + '-' + (dtItemDate.getMonth()+1) + '-' + dtItemDate.getFullYear();

          if(initDateString === dtItemDateString && !this.isDisabled) {
            this.selectDate()
          }
        }
      },
      methods: {
        selectDate() {
          this.$emit('dateSelected', this.dateItem);
        }
      },
      data() {
        return {
          isDisabled: (() => {
            let date = new Date(this.dateItem.date);
            let today = new Date();

            const dateInPast = function (firstDate, secondDate) {
              return firstDate.setHours(0, 0, 0, 0) < secondDate.setHours(0, 0, 0, 0);
            };

            if (this.dateItem.isDisabled) {
              return true;
            } else {
              return dateInPast(date, today);
            }
          })(),
          isBestPrice: (() => {
            return this.dateItem.isBestPrice;
          })(),
          isOutOfMonth: (() => {
            let date = new Date(this.dateItem.date);
            return date.getMonth() + 1 !== this.shownMonth;
          })(),
          dayOfMonth: (() => {
            let date = new Date(this.dateItem.date);
            return date.getDate().toString().padStart(2, '0');
          })(),
          dayPrice: (() => {
            return this.dateItem.price;
          })()
        }
      },
      watch: {
        dateItem: {
          handler(newObj) {
            this.dayPrice = newObj.price;
            this.isBestPrice = !!newObj.isBestPrice;
          },
        }
      }
    }
</script>
